import { render, staticRenderFns } from "./DashboardHeaderKPI.vue?vue&type=template&id=825fde9c&scoped=true&"
import script from "./DashboardHeaderKPI.vue?vue&type=script&lang=js&"
export * from "./DashboardHeaderKPI.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeaderKPI.vue?vue&type=style&index=0&id=825fde9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825fde9c",
  null
  
)

export default component.exports